module.exports = __webpack_public_path__ + "static/media/6.6e940bce.png";